import { useEffect, useState } from 'react';
import { baseUrl, factionNames } from './useFactionData.constant';
import X2JS from 'x2js';
import { Catalogue } from '../../types/Library/Library';
import { convertListToSimplified, SimplifiedSelectionEntry } from '../../types/Library/LibrarySimplified';

function useFactionData() {
  const [data, setData] = useState<Map<string, SimplifiedSelectionEntry[] | undefined>>(new Map());

  useEffect(() => {
    factionNames.forEach((factionName) => {
      const url = encodeURI(`${baseUrl}${factionName} - Library.cat`);
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const x2js = new X2JS({
            arrayAccessFormPaths: [
              /characteristic$/, 
              /categoryLink$/, 
              /profile$/, 
              /selectionEntry$/, 
              /entryLink$/, 
              /infoLink$/,
              /constraint$/
            ],
          });
          const document = x2js.xml2js<Catalogue>(text);
          setData((prev) => {
            const newMap = new Map(prev);
            let list: SimplifiedSelectionEntry[] = [];
            if(document.catalogue?.sharedSelectionEntries) {
              list = convertListToSimplified(document.catalogue.sharedSelectionEntries.selectionEntry);
            }
            newMap.set(factionName, list);
            return newMap;
          });
        });
    });
  }, []);

  return { data };
}

export default useFactionData;